// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Nanoid from "nanoid";
import * as Currency from "../../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as SlabList from "../../../sidebars/create-core-pricing/SlabsForm/SlabList.bs.js";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as ModalBody from "../../../../library/reuseable-components/ModalBody.bs.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as FreeSlabCmp from "../../../sidebars/create-core-pricing/SlabsForm/FreeSlabCmp.bs.js";
import * as LastSlabCmp from "../../../sidebars/create-core-pricing/SlabsForm/LastSlabCmp.bs.js";
import * as ModalFooter from "../../../../library/reuseable-components/ModalFooter.bs.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CorePricingUtils from "../../../../library/utils/CorePricingUtils.bs.js";
import * as AccordionV2$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionV2.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as ModificationPreviewVm from "../../../../vm-mapper/modification-preview/ModificationPreviewVm.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PricingDashboardConfig from "../../../../library/utils/PricingDashboardConfig.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";
import * as ModificationBaseDetailsCard from "../../modification-details/ModificationBaseDetailsCard.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../assets/PricingDashboardAssetsManager.bs.js";

var error_sign = PricingDashboardAssetsManager.getImage("error-sign.svg");

var disabled_add_icon = PricingDashboardAssetsManager.getImage("disabled-add-icon.svg");

var add_icon = PricingDashboardAssetsManager.getImage("add-icon.svg");

var validators_last_slab = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var last_slab = param.last_slab;
      if (last_slab.is_valid) {
        return {
                TAG: /* Ok */0,
                _0: last_slab
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Last Slab is Invalid. Please rectify it before proceeding."
              };
      }
    })
};

var validators_slabs = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var slabs = param.slabs;
      var invalid_slabs = List.map((function (slab) {
              return slab.slab_no + 1 | 0;
            }), List.find_all(function (slab) {
                  return !slab.isValid;
                })(slabs));
      if (List.length(invalid_slabs) === 0) {
        return {
                TAG: /* Ok */0,
                _0: List.map((function (slab) {
                        return {
                                slab_km: Caml_format.caml_int_of_string(slab.end_distance),
                                price_per_min: CurrencyMajorMinorMapper.currencyToBase(Currency.fromString(slab.price_per_min)),
                                price_per_km: CurrencyMajorMinorMapper.currencyToBase(Currency.fromString(slab.price_per_km))
                              };
                      }), slabs)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "An error has occured in one of the slabs [ " + (CorePricingUtils.concatInvalidSlabs(invalid_slabs, undefined, undefined) + " ] . Please rectify it before proceeding.")
              };
      }
    })
};

var validators = {
  last_slab: validators_last_slab,
  slabs: validators_slabs
};

function initialFieldsStatuses(_input) {
  return {
          last_slab: /* Pristine */0,
          slabs: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            last_slab: /* Pristine */0,
            slabs: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.last_slab;
  var match_0 = match ? match._0 : Curry._1(validators.last_slab.validate, input);
  var match$1 = fieldsStatuses.slabs;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.slabs.validate, input);
  var last_slabResult = match_0;
  var last_slabResult$1;
  if (last_slabResult.TAG === /* Ok */0) {
    var slabsResult = match_0$1;
    if (slabsResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                slabs: slabsResult._0,
                last_slab: last_slabResult._0
              },
              fieldsStatuses: {
                last_slab: /* Dirty */{
                  _0: last_slabResult,
                  _1: /* Shown */0
                },
                slabs: /* Dirty */{
                  _0: slabsResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    last_slabResult$1 = last_slabResult;
  } else {
    last_slabResult$1 = last_slabResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            last_slab: /* Dirty */{
              _0: last_slabResult$1,
              _1: /* Shown */0
            },
            slabs: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurLast_slabField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.last_slab, validators_last_slab, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  last_slab: status,
                                  slabs: init.slabs
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSlabsField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.slabs, validators_slabs, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  last_slab: init.last_slab,
                                  slabs: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateLast_slabField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.last_slab, state.submissionStatus, validators_last_slab, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            last_slab: status,
                                            slabs: init.slabs
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSlabsField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.slabs, state.submissionStatus, validators_slabs, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            last_slab: init.last_slab,
                                            slabs: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                last_slab: /* Pristine */0,
                                slabs: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                last_slab: /* Pristine */0,
                                slabs: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateLast_slab: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateLast_slabField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSlabs: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSlabsField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurLast_slab: (function (param) {
              return Curry._1(dispatch, /* BlurLast_slabField */0);
            }),
          blurSlabs: (function (param) {
              return Curry._1(dispatch, /* BlurSlabsField */1);
            }),
          last_slabResult: Formality.exposeFieldResult(state.fieldsStatuses.last_slab),
          slabsResult: Formality.exposeFieldResult(state.fieldsStatuses.slabs),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.last_slab || match.slabs) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function addNewSlab(existingSlabs, updateSlabs) {
  var lastSlab = List.length(existingSlabs) === 0 ? undefined : List.nth_opt(existingSlabs, List.length(existingSlabs) - 1 | 0);
  var newSlab_id = Nanoid.nanoid();
  var newSlab_slab_no = Belt_Option.mapWithDefault(lastSlab, 0, (function (l) {
          return l.slab_no + 1 | 0;
        }));
  var newSlab = {
    id: newSlab_id,
    slab_no: newSlab_slab_no,
    end_distance: "",
    price_per_min: "",
    price_per_km: "",
    isValid: false
  };
  return Curry._1(updateSlabs, List.append(existingSlabs, {
                  hd: newSlab,
                  tl: /* [] */0
                }));
}

function isStartDistanceValid(start_distance, end_distance) {
  return Belt_Option.mapWithDefault(start_distance, false, (function (v) {
                return v < Caml_format.caml_int_of_string(end_distance);
              }));
}

function getErrorComponent(result) {
  if (result.TAG === /* Ok */0) {
    return null;
  } else {
    return React.createElement(Row$Catalyst.make, {
                children: null,
                className: "c-footer-error-message"
              }, React.createElement("img", {
                    src: error_sign
                  }), result._0);
  }
}

function getLastSlabStartDistance(free_kms, slabs) {
  if (List.length(slabs) === 0) {
    return String(free_kms);
  } else {
    return List.nth(slabs, List.length(slabs) - 1 | 0).end_distance;
  }
}

function AbModificationSlabDetailsForm$AddSlabBtn(Props) {
  var isDisabled = Props.isDisabled;
  var callback = Props.callback;
  if (isDisabled) {
    return React.createElement("div", {
                className: "add-slab",
                onClick: (function (param) {
                    return Curry._1(callback, undefined);
                  })
              }, React.createElement("div", undefined, React.createElement("b", {
                        className: "add-slab-title"
                      }, "Add Slab "), " • max 7 slabs"), React.createElement("img", {
                    src: add_icon
                  }));
  } else {
    return React.createElement("div", {
                className: "disabled-add-slab"
              }, React.createElement("div", undefined, React.createElement("b", {
                        className: "add-slab-title"
                      }, "Add Slab "), " • Fill all the details in slabs to create more"), React.createElement("img", {
                    src: disabled_add_icon
                  }));
  }
}

var AddSlabBtn = {
  make: AbModificationSlabDetailsForm$AddSlabBtn
};

function AbModificationSlabDetailsForm(Props) {
  var core_pricing = Props.core_pricing;
  var base_details = Props.base_details;
  var title = Props.title;
  var active_slabs = Props.active_slabs;
  var submitted_slabs = Props.submitted_slabs;
  var onNext = Props.onNext;
  var onBack = Props.onBack;
  var free_slab_params = Props.free_slab_params;
  var match = React.useState(function () {
        return false;
      });
  var toggleSubmitted = match[1];
  var isSubmitted = match[0];
  var tmp;
  var exit = 0;
  var slabs;
  if (active_slabs !== undefined) {
    if (submitted_slabs !== undefined) {
      slabs = submitted_slabs;
      exit = 1;
    } else {
      slabs = active_slabs;
      exit = 1;
    }
  } else if (submitted_slabs !== undefined) {
    if (submitted_slabs !== undefined) {
      slabs = submitted_slabs;
      exit = 1;
    } else {
      slabs = active_slabs;
      exit = 1;
    }
  } else {
    tmp = /* [] */0;
  }
  if (exit === 1) {
    tmp = List.mapi((function (index, slab) {
            var start_distance = index === 0 ? free_slab_params.free_kms : List.nth(slabs, index - 1 | 0).slab_km;
            return {
                    id: Nanoid.nanoid(),
                    slab_no: index,
                    end_distance: String(slab.slab_km),
                    price_per_min: Currency.toString(CurrencyMajorMinorMapper.baseToCurrency(slab.price_per_min)),
                    price_per_km: Currency.toString(CurrencyMajorMinorMapper.baseToCurrency(slab.price_per_km)),
                    isValid: isStartDistanceValid(start_distance, String(slab.slab_km))
                  };
          }), Belt_List.keepWithIndex(slabs, (function (param, index) {
                return (List.length(slabs) - 1 | 0) !== index;
              })));
  }
  var tmp$1;
  var exit$1 = 0;
  var slabs$1;
  if (active_slabs !== undefined) {
    if (submitted_slabs !== undefined) {
      slabs$1 = submitted_slabs;
      exit$1 = 1;
    } else {
      slabs$1 = active_slabs;
      exit$1 = 1;
    }
  } else if (submitted_slabs !== undefined) {
    if (submitted_slabs !== undefined) {
      slabs$1 = submitted_slabs;
      exit$1 = 1;
    } else {
      slabs$1 = active_slabs;
      exit$1 = 1;
    }
  } else {
    tmp$1 = {
      price_per_min: "",
      price_per_km: "",
      is_valid: false
    };
  }
  if (exit$1 === 1) {
    var last_slab = List.hd(Belt_List.keepWithIndex(slabs$1, (function (param, index) {
                return (List.length(slabs$1) - 1 | 0) === index;
              })));
    tmp$1 = {
      price_per_min: Currency.toString(CurrencyMajorMinorMapper.baseToCurrency(last_slab.price_per_min)),
      price_per_km: Currency.toString(CurrencyMajorMinorMapper.baseToCurrency(last_slab.price_per_km)),
      is_valid: true
    };
  }
  var form = useForm({
        slabs: tmp,
        last_slab: tmp$1
      }, (function (output, submissionCbs) {
          Curry._1(onNext, List.append(output.slabs, {
                    hd: {
                      slab_km: PricingDashboardConfig.last_slab_upper_limit,
                      price_per_min: CurrencyMajorMinorMapper.currencyToBase(Currency.fromString(output.last_slab.price_per_min)),
                      price_per_km: CurrencyMajorMinorMapper.currencyToBase(Currency.fromString(output.last_slab.price_per_km))
                    },
                    tl: /* [] */0
                  }));
          return Curry._1(submissionCbs.reset, undefined);
        }));
  var match$1 = (PricingDashboardConfig.max_number_of_slabs - 1 | 0) === List.length(form.input.slabs);
  var match$2 = form.last_slabResult;
  var match$3 = form.slabsResult;
  return React.createElement(React.Fragment, undefined, React.createElement(ModalBody.make, {
                  className: "slab-details-container",
                  children: null
                }, React.createElement(AccordionV2$Catalyst.make, {
                      panels: {
                        hd: AccordionTypes$Catalyst.make_props({
                              TAG: /* Text */0,
                              _0: title
                            }, undefined, undefined, React.createElement(ModificationBaseDetailsCard.make, {
                                  base_details: ModificationPreviewVm.serializedAbBaseDetails(core_pricing, base_details)
                                }), undefined),
                        tl: /* [] */0
                      },
                      defaultOpen: -1
                    }), free_slab_params.free_kms === 0 ? null : React.createElement(FreeSlabCmp.make, {
                        free_kms: free_slab_params.free_kms,
                        price_per_min: free_slab_params.price_per_min
                      }), React.createElement(SlabList.make, {
                      slabs: form.input.slabs,
                      isSubmitted: isSubmitted,
                      updateSlabs: (function (slabs) {
                          return Curry._2(form.updateSlabs, (function (input, param) {
                                        return {
                                                slabs: slabs,
                                                last_slab: input.last_slab
                                              };
                                      }), /* [] */0);
                        }),
                      free_kms: free_slab_params.free_kms
                    }), match$1 ? null : React.createElement(AbModificationSlabDetailsForm$AddSlabBtn, {
                        isDisabled: Curry._1(form.valid, undefined),
                        callback: (function (param) {
                            return addNewSlab(form.input.slabs, (function (slabs) {
                                          return Curry._2(form.updateSlabs, (function (input, param) {
                                                        return {
                                                                slabs: slabs,
                                                                last_slab: input.last_slab
                                                              };
                                                      }), slabs);
                                        }));
                          })
                      }), React.createElement(LastSlabCmp.make, {
                      start_distance: getLastSlabStartDistance(free_slab_params.free_kms, form.input.slabs),
                      price_per_min: form.input.last_slab.price_per_min,
                      price_per_km: form.input.last_slab.price_per_km,
                      isSubmitted: isSubmitted,
                      onChange: (function (price_per_min, price_per_km, is_valid) {
                          return Curry._2(form.updateLast_slab, (function (input, last_slab) {
                                        return {
                                                slabs: input.slabs,
                                                last_slab: last_slab
                                              };
                                      }), {
                                      price_per_min: price_per_min,
                                      price_per_km: price_per_km,
                                      is_valid: is_valid
                                    });
                        })
                    })), React.createElement(ModalFooter.make, {
                  children: null
                }, match$2 !== undefined ? (
                    match$3 !== undefined ? getErrorComponent(match$3) : getErrorComponent(match$2)
                  ) : (
                    match$3 !== undefined ? getErrorComponent(match$3) : null
                  ), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Previous"
                          }, undefined, (function (param) {
                              return Curry._1(onBack, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined)
                    }), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Next"
                          }, undefined, (function (param) {
                              Curry._1(toggleSubmitted, (function (param) {
                                      return true;
                                    }));
                              return Curry._1(form.submit, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined)
                    })));
}

var make = AbModificationSlabDetailsForm;

export {
  error_sign ,
  disabled_add_icon ,
  add_icon ,
  Form ,
  addNewSlab ,
  isStartDistanceValid ,
  getErrorComponent ,
  getLastSlabStartDistance ,
  AddSlabBtn ,
  make ,
  
}
/* error_sign Not a pure module */
